import get from 'lodash/get';
import { createSelector } from 'reselect';

export const selectDashboardEditMode = (state) => get(state, 'dashboard.editMode', false);
export const selectIsLayoutSaving = (state) => get(state, 'dashboard.isLayoutSaving', false);

export const selectActiveFeeds = (state) => {
  const tools = get(state, 'dashboard.tools', []);
  return tools.length >= 5 ? tools[4].data : null;
};

export const selectActivityFeedShowMore = (state) => {
  const tools = get(state, 'dashboard.tools', []);
  return tools.length >= 5 ? tools[4].showMore !== false : true;
};

export const selectCommandHistory = (state) => get(state, 'dashboard.commandHistory', []);
export const selectIsFetching = (state) => get(state, 'dashboard.isFetching', false);
export const selectIsLoadingState = (state, type) => get(state, `dashboard.loadingState.${type}`, false);
export const selectTools = (state) => get(state, 'dashboard.tools', []);
export const selectReloadVulnerabilities = (state) => get(state, 'dashboard.reloadVulnerabilities', false);
export const selectTotalVulns = (state) => get(state, 'dashboard.currentWs.stats.total_vulns', 0);
export const selectIsFinishedLoad = (state) => get(state, 'dashboard.finishedLoad', false);

const selectTopAssets = (state) => get(state, 'dashboard.topAssets', []);
const ASSETS_LIMIT_TO_SELECT = 8;

export const selectTop8AssetsByCriticalHigh = createSelector(
  [selectTopAssets],
  (assets) => {
    if (!assets) return [];
    const rawRows = assets.rows || assets;
    if (!Array.isArray(rawRows)) return [];
    // filter endpoint wraps each row in { value: {...} }
    const hosts = rawRows.map(item => item.value || item);
    return hosts
      .map(asset => {
        const sc = asset.severity_counts || {};
        const criticalCount = sc.critical || 0;
        const highCount = sc.high || 0;
        const medCount = sc.med || 0;
        const totalVulns = asset.vulns || sc.total || 0;
        let highestSeverity = 'none';
        if (criticalCount > 0) highestSeverity = 'critical';
        else if (highCount > 0) highestSeverity = 'high';
        else if (medCount > 0) highestSeverity = 'med';
        else if (totalVulns > 0) highestSeverity = 'low';

        return {
          ...asset,
          critical_count: criticalCount,
          high_count: highCount,
          med_count: medCount,
          totalCriticalHigh: criticalCount + highCount,
          totalVulns,
          highestSeverity
        };
      })
      .sort((a, b) => b.totalCriticalHigh - a.totalCriticalHigh)
      .slice(0, ASSETS_LIMIT_TO_SELECT);
  }
);

export const selectTotalAssetsCount = createSelector(
  [selectTopAssets],
  (assets) => {
    if (!assets) return 0;
    // filter endpoint returns { count: N }, legacy returns { total_rows: N }
    if (assets.count !== undefined) return assets.count;
    if (assets.total_rows !== undefined) return assets.total_rows;
    if (Array.isArray(assets.rows)) return assets.rows.length;
    return 0;
  }
);

export const selectPentestStatus = (state) => get(state, 'dashboard.pentestStatus', null);
export const selectRiskPosture = (state) => get(state, 'dashboard.riskPosture', null);
export const selectNewServices = (state) => get(state, 'dashboard.newServices', []);
export const selectNewAssets = (state) => get(state, 'dashboard.newAssets', []);
export const selectFoundVsClosedTimeline = (state) => get(state, 'dashboard.foundVsClosedTimeline', []);

export const select14DayTrend = (state) => {
  const riskPosture = selectRiskPosture(state);
  if (!riskPosture || !riskPosture.stats) return 0;
  return riskPosture.stats.vulnerabilities_14d_trend || 0;
};

export const selectExploitableCount = (state) => {
  const riskPosture = selectRiskPosture(state);
  if (!riskPosture || !riskPosture.stats) return 0;
  return riskPosture.stats.exploitable_count || 0;
};
